import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AdminService } from '@app/services/adminService'
import { toast } from '@app/components/ui/Toast/toast'
import type { UserRole } from '@app/types'
import { USERS_QUERY_KEY } from '../utils/Admin.constants'

export const useInviteAdminUsers = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      emails,
      clientName,
      roles,
    }: {
      emails: string[]
      clientName: string
      roles: UserRole[]
    }) => AdminService.inviteUsers(emails, clientName, roles),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USERS_QUERY_KEY] })
    },
    onError: () =>
      toast({
        description: `Failed to send invites.`,
        type: 'error',
      }),
  })
}
